export enum FeeCalculationApplyingTypes {
    PreMargin = 0,
    PostMargin = 1,
}
